import { GoOverAgainBriefing } from '@/shared/model/briefing-widget.model';

export function updateLocalStorageDsConnectomeLanguage(languageInput: string) {
  if (languageInput) {
    const dsConnectome = JSON.parse(localStorage.getItem('localStorageUser'));
    if (dsConnectome && dsConnectome?.id) {
      dsConnectome.langKey = languageInput;
      localStorage.setItem('localStorageUser', JSON.stringify(dsConnectome));
    }
  }
}

export function handleRemoveLocalStorageGoOverAgainData(bpIdsInput: string[]) {
  if (localStorage.getItem('localStorageBriefingGoOverAgainData')?.length > 0 && bpIdsInput?.length > 0) {
    let parsedData: GoOverAgainBriefing[] = JSON.parse(localStorage.getItem('localStorageBriefingGoOverAgainData'));

    if (parsedData?.length > 0 && bpIdsInput?.length > 0) {
      parsedData = parsedData.filter(item => !bpIdsInput.includes(item?.bpId));

      if (parsedData?.length > 0) {
        localStorage.setItem('localStorageBriefingGoOverAgainData', JSON.stringify(parsedData));
      } else {
        localStorage.setItem('localStorageBriefingGoOverAgainData', '');
      }
    }
  }
}

export function updateLocalStorageUserLanguage(languageInput: string) {
  if (languageInput) {
    const tempUser = JSON.parse(localStorage.getItem('localStorageUser'));

    if (tempUser && tempUser?.langKey) {
      tempUser.langKey = languageInput;
      localStorage.setItem('localStorageUser', JSON.stringify(tempUser));
    }
  }
}

export function updateLocalStorageUserContentLanguage(contentLanguages?: string) {
  if (contentLanguages?.length > 0) {
    const tempUser = JSON.parse(localStorage.getItem('localStorageUser'));

    if (tempUser) {
      tempUser.contentLanguages = contentLanguages;

      localStorage.setItem('localStorageUser', JSON.stringify(tempUser));
    }
  }
}
